import { useState, useSyncExternalStore } from "react";
import { RouterProvider } from "react-router";
import { wrapRoute } from "./guards";
import { AppProviders } from "./providers";
import { createAppRouter } from "./router";
import { probesRuntime } from "./routes";

export function App() {
  const [router] = useState(() => createAppRouter({ guards: true, wrap: wrapRoute }));
  const pathname = useSyncExternalStore(router.subscribe, () => router.state.location.pathname);
  return (
    <AppProviders probeRuntime={probesRuntime(pathname)}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
